import { STANDARD_EVENTS } from "../types/Amplitude";
import { formatTrackingNameValue } from "../utils/general";

// PageView Events
export const trackPageView = (data) => ({
  type: STANDARD_EVENTS.Page_View,
  data,
});

// Ecommerce Events
export const trackViewItemList = (data) => ({
  type: STANDARD_EVENTS.View_Item_List,
  data,
});

export const trackSelectItem = (data) => ({
  type: STANDARD_EVENTS.Select_Item,
  data,
});

export const trackViewItem = (data) => ({
  type: STANDARD_EVENTS.View_Item,
  data,
});

export const trackAddToShopifyCart = (data) => ({
  type: STANDARD_EVENTS.Add_To_Shopify_Cart,
  data,
});

export const trackRemoveItemFromCart = (data) => ({
  type: STANDARD_EVENTS.Remove_From_Cart,
  data,
});

export const trackViewCart = (data) => ({
  type: STANDARD_EVENTS.View_Cart,
  data,
});

export const trackCheckout = ({ cartItems, ...rest }) => ({
  type: STANDARD_EVENTS.Checkout,
  data: {
    ...rest,
    cartItems: JSON.stringify(cartItems),
  },
});

// Interaction Events
export const trackSocialShare = (data) => ({
  type: STANDARD_EVENTS.Social_Share,
  data,
});

export const trackAppDownload = (data) => ({
  type: STANDARD_EVENTS.App_Download,
  data,
});

export const trackFileDownload = (data) => ({
  type: STANDARD_EVENTS.File_Download,
  data,
});

export const trackGenerateLead = (data) => ({
  type: STANDARD_EVENTS.Generate_Lead,
  data,
});

export const trackEmailSignup = (data) => ({
  type: STANDARD_EVENTS.Email_Signup,
  data,
});

export const trackAudioStart = (data) => ({
  type: STANDARD_EVENTS.Audio_Start,
  data,
});

export const trackFaqAction = (data) => ({
  type: STANDARD_EVENTS.Faq_Action,
  data,
});

export const trackFaqLoadMore = (data) => ({
  type: STANDARD_EVENTS.Faq_Load_More,
  data,
});

export const trackReviewsCta = (data) => ({
  type: STANDARD_EVENTS.Reviews_Cta,
  data,
});

export const trackNavigation = (data) => ({
  type: STANDARD_EVENTS.Navigation,
  data,
});

export const trackCtaClick = (data) => ({
  type: STANDARD_EVENTS.Cta_Click,
  data,
});

export const trackItemDetails = (data) => ({
  type: STANDARD_EVENTS.Item_Details,
  data,
});

// Page View Events
export const trackBuyNowTapped = (data) => ({
  type: STANDARD_EVENTS.Buy_Now_Button_Tapped,
  data,
});

// This is because we can't fire off Add to Cart in Shopify
// since we auto-add to cart and direct users to the Cart page
export const trackAddToCart = (data) => ({
  type: STANDARD_EVENTS.Add_To_Cart,
  data,
});

export const trackCloseCart = (data) => ({
  type: STANDARD_EVENTS.Close_Cart,
  data,
});

export const trackOpenCart = (data) => ({
  type: STANDARD_EVENTS.Open_Cart,
  data,
});

export const trackShopButtonClick = (data) => ({
  type: STANDARD_EVENTS.Shop_Button_Clicked,
  data,
});

export const trackDecreaseQuantityClick = (data) => ({
  type: STANDARD_EVENTS.Decrease_Quantity,
  data,
});

export const trackIncreaseQuantityClick = (data) => ({
  type: STANDARD_EVENTS.Increase_Quantity,
  data,
});

export const trackMailchimpSignup = (data) => ({
  type: STANDARD_EVENTS.Mailchimp_Signup_Completed,
  data,
});

export const trackShopNavToggleClick = (data) => () => ({
  type: STANDARD_EVENTS.Shop_Nav_Toggle_Clicked,
  data,
});

export const trackShopSubnavLinkClick = (data) => () => ({
  type: STANDARD_EVENTS.Shop_Subnav_Link_Clicked,
  data,
});

export const trackShopMobileMenuIconClick = (data) => () => ({
  type: STANDARD_EVENTS.Shop_Mobile_Menu_Icon_Clicked,
  data,
});

export const trackLinkClick = (data) => ({
  type: STANDARD_EVENTS.Link_Clicked,
  data,
});

export const trackLeadGenSignup = (data) => ({
  type: STANDARD_EVENTS.Lead_Gen_Signup_Completed,
  data: {
    ...data,
    customEvent: formatTrackingNameValue(
      STANDARD_EVENTS.Lead_Gen_Signup_Completed
    ),
  },
});

export const trackMainNavLinkClick = (data) => ({
  type: STANDARD_EVENTS.Main_Nav_Link_Click,
  data: {
    ...data,
    customEvent: formatTrackingNameValue(STANDARD_EVENTS.Main_Nav_Link_Click),
  },
});

export const trackSubnavLinkClick = (data) => ({
  type: STANDARD_EVENTS.Subnav_Link_Click,
  data: {
    ...data,
    customEvent: formatTrackingNameValue(STANDARD_EVENTS.Subnav_Link_Click),
  },
});

export const trackAccordionToggleClick = (data) => ({
  type: STANDARD_EVENTS.Accordion_Toggle_Click,
  data: {
    ...data,
    customEvent: formatTrackingNameValue(
      STANDARD_EVENTS.Accordion_Toggle_Click
    ),
  },
});

export const trackLoadMore = (data) => ({
  type: STANDARD_EVENTS.Load_More,
  data: {
    ...data,
    customEvent: formatTrackingNameValue(STANDARD_EVENTS.Load_More),
  },
});

export const trackCarouselToggleClick = (data) => ({
  type: STANDARD_EVENTS.Carousel_Toggle_Click,
  data: {
    ...data,
    customEvent: formatTrackingNameValue(STANDARD_EVENTS.Carousel_Toggle_Click),
  },
});

export const trackTabClick = (data) => ({
  type: STANDARD_EVENTS.Tab_Click,
  data: {
    ...data,
    customEvent: formatTrackingNameValue(STANDARD_EVENTS.Tab_Click),
  },
});

export const trackVideoComplete = (data) => ({
  type: STANDARD_EVENTS.Video_Complete,
  data,
});

export const trackVideoProgress = (data) => ({
  type: STANDARD_EVENTS.Video_Progress,
  data,
});

export const trackVideoStart = (data) => ({
  type: STANDARD_EVENTS.Video_Start,
  data,
});

const TrackingActions = {
  trackPageView,
  trackViewItemList,
  trackSelectItem,
  trackViewItem,
  trackAddToShopifyCart,
  trackRemoveItemFromCart,
  trackViewCart,
  trackCheckout,
  trackSocialShare,
  trackAppDownload,
  trackFileDownload,
  trackGenerateLead,
  trackEmailSignup,
  trackAudioStart,
  trackFaqAction,
  trackFaqLoadMore,
  trackReviewsCta,
  trackNavigation,
  trackCtaClick,
  trackItemDetails,
  trackBuyNowTapped,
  trackAddToCart,
  trackCloseCart,
  trackOpenCart,
  trackShopButtonClick,
  trackDecreaseQuantityClick,
  trackIncreaseQuantityClick,
  trackMailchimpSignup,
  trackLinkClick,
  trackLeadGenSignup,
  trackAccordionToggleClick,
  trackLoadMore,
  trackCarouselToggleClick,
  trackTabClick,
  trackVideoComplete,
  trackVideoProgress,
  trackVideoStart,
  // New Navigation
  trackShopNavToggleClick,
  trackShopSubnavLinkClick,
  trackShopMobileMenuIconClick,
  trackMainNavLinkClick,
  trackSubnavLinkClick,
};

export default TrackingActions;
